import { createSlice, PayloadAction } from '@reduxjs/toolkit';


interface IModalViewStore {
        isModalShow: boolean,
        ModalViewComponent: string
}
const ModaViewSlice = createSlice({
    name: "Global_Modal_View_State",
    initialState: {isModalShow: false,
                    ModalViewComponent: ''},
    reducers:{
        setModalViewState: (state, action: PayloadAction<IModalViewStore>)=>{
            return {
                isModalShow: action.payload.isModalShow,
                ModalViewComponent: action.payload.ModalViewComponent
            }
        }
    }
})

export const {setModalViewState} = ModaViewSlice.actions
export default ModaViewSlice.reducer